import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
// import _ from 'lodash'
import ReactTable from 'react-table'
import { actions } from '../../redux/modules/usersActions'
import { actions as userActions } from '../../redux/modules/userActions'
import { Form, Modal, Input, Popconfirm, Button, Checkbox, Tooltip, Row, message } from 'antd'
import 'react-table/react-table.css'
import { filterCaseInsensitive } from '../../util'
import PaginationComponent from '../../components/PaginationComponent'

const propTypes = {}
const FormItem = Form.Item

function listRoles(rolesArray) {
  let rolesList = ''
  rolesArray.forEach(role => (rolesList += role.name + ', '))
  return rolesList.substr(0, rolesList.length - 2)
}

class Users extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedRoles: null,
      contentData: null,
      userRoles: [
        {
          id: 1,
          name: 'Admin',
          description: 'Can perform administrative actions throughout the site.'
        },
        {
          id: 3,
          name: 'General',
          description: 'General user type'
        },
        {
          id: 4,
          name: 'Controller 1',
          description: 'Is assigned Payment Requests, AIAs, and Invoices when they are first created. When an AIA is resubmitted, they are again assigned to it.' // prettier-ignore
        },
        {
          id: 5,
          name: 'Controller 2',
          description: 'Is assigned an AIA when it is sent.'
        },
        {
          id: 7,
          name: 'Receptionist',
          description: 'Is assigned a follow up when a Proposal is sent or received.'
        },
        {
          id: 8,
          name: 'Material Man',
          description: 'Is assigned a follow up when a Material Request is created.'
        },
        {
          id: 9,
          name: 'Driver',
          description: 'Driver role'
        },
        {
          id: 10,
          name: 'Maintenance/DOB',
          description: 'Maintenance/DOB role'
        },
        {
          id: 11,
          name: 'HUB Supervisor',
          description: 'HUB Supervisor'
        },
        {
          id: 12,
          name: 'Field',
          description: 'Field'
        }
      ]
    }
  }
  componentWillMount() {
    this.props.usersRefresh()
  }

  onChange = checkedValues => {
    this.setState({
      ...this.state,
      selectedRoles: checkedValues
    })
  }

  handleRowClick = row => {
    const selectedRoles = row ? row.user_roles.map(role => role.id) : null
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row,
      selectedRoles
    })
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null,
      selectedRoles: null
    })
  }

  handleSave = update => {
    const { contentData, selectedRoles } = this.state
    const { userUpdate, userCreate, form } = this.props
    const { confirm_password, ...data } = form.getFieldsValue() // eslint-disable-line no-unused-vars
    data.user_roles = selectedRoles
    form.validateFields(['email'], (err, values) => {
      if (err) {
        return message.error('You must input a valid email!')
      } else {
        if (selectedRoles == null || selectedRoles.length <= 0) {
          return message.error('You must select at leat one role!')
        }
        if (update) {
          userUpdate(contentData.id, data)
          this.setState({
            selectedRoles: null,
            contentData: null,
            currentId: 0,
            modalVisible: false
          })
        } else {
          if (data.password !== confirm_password) {
            return message.error('Entered password and confirmed password do not match!')
          }
          userCreate(data)
          this.setState({
            selectedRoles: null,
            contentData: null,
            currentId: 0,
            modalVisible: false
          })
        }

        this.props.form.resetFields()
      }
    })
  }

  confirmDelete = () => {
    const { contentData } = this.state
    const { userDelete } = this.props
    userDelete(contentData.id)
    this.props.form.resetFields()
    this.setState({
      selectedRoles: null,
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ selectedRoles: null, contentData: null, currentId: 0, modalVisible: false })
  }

  showRoles = () => {
    const { contentData, userRoles } = this.state
    if (contentData && contentData.user_roles) {
      return userRoles.map(role => (
        <Row key={role.id}>
          <Tooltip placement="rightTop" title={role.description}>
            <Checkbox checked value={role.id}>
              {role.name}
            </Checkbox>
          </Tooltip>
        </Row>
      ))
    } else {
      return userRoles.map(role => (
        <Row key={role.id}>
          <Tooltip placement="rightTop" title={role.description}>
            <Checkbox value={role.id}> {role.name}</Checkbox>
          </Tooltip>
        </Row>
      ))
    }
  }

  cleanForm = () => {
    this.props.form.resetFields()
    this.setState({ selectedRoles: null, contentData: null, currentId: 0, modalVisible: false })
  }

  render() {
    const { payload } = this.props.usersActions
    const { contentData, selectedRoles } = this.state
    const { getFieldDecorator } = this.props.form

    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <Modal
            afterClose={this.cleanForm}
            visible={this.state.modalVisible}
            title="User"
            okText={contentData ? 'Save Changes' : 'Add User'}
            onCancel={this.handleCancel}
            onOk={this.handleSave.bind(this, contentData ? true : false)}
          >
            <Form layout="vertical">
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="First Name">
                    {getFieldDecorator('first_name', {
                      rules: [
                        {
                          required: true,
                          message: 'You must enter a first name'
                        }
                      ],
                      initialValue: contentData ? contentData.first_name : ''
                    })(<Input placeholder="User's first name" />)}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Last Name">
                    {getFieldDecorator('last_name', {
                      rules: [
                        {
                          required: true,
                          message: 'You must enter a last name'
                        }
                      ],
                      initialValue: contentData ? contentData.last_name : ''
                    })(<Input placeholder="User's last name" />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Email">
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          required: true,
                          type: 'email',
                          message: 'You must enter an email address'
                        }
                      ],
                      initialValue: contentData ? contentData.email : ''
                    })(<Input placeholder="Email Address" />)}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Username">
                    {getFieldDecorator('username', {
                      rules: [
                        {
                          required: true,
                          message: 'Choose a username'
                        }
                      ],
                      initialValue: contentData ? contentData.username : ''
                    })(<Input placeholder="Type in a username" />)}
                  </FormItem>
                </div>
              </div>
              <div>
                <Checkbox.Group value={selectedRoles} onChange={this.onChange}>
                  <Row> {this.showRoles()} </Row>
                </Checkbox.Group>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Password">
                    {getFieldDecorator('password', {})(
                      <Input type="password" placeholder="Choose a password" />
                    )}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Confirm Password">
                    {getFieldDecorator('confirm_password', {})(
                      <Input type="password" placeholder="Confirm your password" />
                    )}
                  </FormItem>
                </div>
              </div>
            </Form>
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Modal>
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/users">Users</Link>
                </li>
              </ol>
            </nav>
            <h2>Users</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Users
                <div className="jobsBarAdd">
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;
                  <div onClick={() => this.handleAddButton()} className="addJobLabel">
                    NEW USER
                  </div>
                </div>
              </div>
              <ReactTable
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                data={payload.data}
                getTrProps={(state, rowInfo, column, instance) => ({
                  onClick: e => this.handleRowClick(rowInfo.original)
                })}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Name',
                        id: 'first_name',
                        accessor: 'first_name',
                        width: 150,
                        Cell: d => {
                          const r = `${d.original.first_name} ${d.original.last_name}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Email Address',
                        id: 'email',
                        accessor: 'email',
                        width: 200,
                        Cell: d => <Tooltip title={d.original.email}>{d.original.email}</Tooltip>
                      },
                      {
                        Header: 'Username',
                        id: 'username',
                        accessor: 'username',
                        width: 100,
                        Cell: d => (
                          <Tooltip title={d.original.username}>{d.original.username}</Tooltip>
                        )
                      },
                      {
                        Header: 'Roles',
                        id: 'roles',
                        accessor: row => listRoles(row.user_roles),
                        Cell: row => {
                          const r = listRoles(row.original.user_roles)
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ usersActions }, ownProps) => ({ usersActions })
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch),
  ...bindActionCreators(userActions, dispatch)
})

Users.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(Users)))



// WEBPACK FOOTER //
// ./src/containers/users/index.js